var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsVideoediting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 36.8,
    viewBox: "0 0 46 36.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "skills_videoediting",
    d: "M20.445,24.215,18.49,28.7,14,30.655,18.49,32.61,20.445,37.1,22.4,32.61l4.485-1.955L22.4,28.7Zm15.3-.69L34.3,26.63l-3.1,1.437L34.3,29.5,35.74,32.61,37.178,29.5l3.1-1.437-3.1-1.437ZM7.45,8,11.7,16.74H19.18L14.925,8h5.118L24.3,16.74h7.475L27.517,8h5.117l4.255,8.74h7.475L40.11,8h6.44a3.31,3.31,0,0,1,2.415,1.035A3.31,3.31,0,0,1,50,11.45v29.9a3.537,3.537,0,0,1-3.45,3.45H7.45a3.31,3.31,0,0,1-2.415-1.035A3.31,3.31,0,0,1,4,41.35V11.45A3.31,3.31,0,0,1,5.035,9.035,3.31,3.31,0,0,1,7.45,8Z",
    transform: "translate(-4 -8)",
    fill: "#5637fa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsVideoediting);
export default __webpack_public_path__ + "static/media/skills_videoediting.e3aa69e3cd9c8ce7ad23d6276ad729a7.svg";
export { ForwardRef as ReactComponent };